import React from 'react';
import { Text } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function GatewayInstallStateView(props) {
  const {
    option: {
      value
    }
  } = props;
  return /*#__PURE__*/_jsx(Text, {
    variant: value ? 'pillSuccess' : 'pill',
    children: value ? 'Installed' : 'Not Installed'
  });
}